<template>
  <button @click.prevent="$emit('click', $event)" :disabled="disabled || loading">
    <b-spinner label="Loading..." v-if="loading" class="mx-4" style="width: 1.3em; height: 1.3em; border-width: 0.2em;">
    </b-spinner>
    <slot v-else></slot>
  </button>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
